<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input placeholder="请输入关键词" v-model="inputss"></el-input>
        </el-form-item>

        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
    </div>
    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="true"
      animated
      :throttle="500"
      v-if="totals != 0"
    >
      <template slot="template">
        <div class="width100 margin-auto margin-top15 pad-top20 alldigital">
          <div
            class="
              width98
              margin-auto
              flex-betweenNowrapAlign
              bordert-bf
              pad-bot20
            "
          >
            <p class="dimensional">全部消息</p>
          </div>
          <div
            class="
              width98
              margin-auto
              flex-betweennocenter
              bordert-bf
              pad-top10 pad-bot20
              cursorpointer
            "
            v-for="(item, index) in pages"
            :key="index"
          >
            <div class="margin-right10" @click="searchDetails(index)">
              <el-badge :is-dot="item.status == 0 ? true : false" class="item">
                <img src="@/assets/barsvg/icon.png" alt="" />
              </el-badge>
            </div>

            <div class="width90" @click="searchDetails(index)">
              <p class="dimensional pad-top10 pad-bot10">{{ item.type }}</p>
              <p class="lineheight30 dimencont">
                {{ item.message }}
              </p>
              <p class="dimencont pad-top20 f12">
                <span>消息类型：{{ item.type }}</span>
                <span class="pad-left20">发送时间：{{ item.create_time }}</span>
              </p>
            </div>
            <el-button @click="designDetails(index)">删除</el-button>
          </div>

          <div
            class="flex-betweennowrap pad-top20 pad-bot20 width98 margin-auto"
          >
            <span class="bluecolor f14 pad-left10"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChanges"
              @current-change="currentchanges"
              :current-page="currentPages"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_pages"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totals"
              background
              v-if="totals != 0"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="totals == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/icon／qsy／zwxx.png')"
        :image-size="200"
        description="您还没有收到消息哟!"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无消息
        </p></el-empty
      >
    </div>
  </div>
</template>
  <script>
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import {
  messageperson,
  messageread,
  messagedel,
} from "@/api/personal/personal.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      thisNums: 1,
      pages: [],
      totals: 0,
      per_pages: 0,
      currentPages: 1,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      inputss: "",
      activeName: "first",
      messgehead: true,
      messgeheads: true,
    };
  },
  components: {
    callback,
    switchcore,
  },

  methods: {
    // 第一个分页个人
    currentchanges(val) {
      this.thisNums = val;
      messageperson({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChanges(val) {
      messageperson({ page: 1, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    resetForm() {
      this.inputss = null;
      this.thisNums = 1;
      //个人消息
      messageperson({ page: this.thisNums }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          if (res.data.data.total == 0) {
            this.messgeheads = false;
          } else {
            this.messgeheads = true;
          }
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    submitForm() {
      if (this.inputss != "") {
        messageperson({ _keywords: this.inputss, page: 1 }).then((res) => {
          if (res.data.code == 200) {
            this.pages = res.data.data.data;
            this.paginations = true;
            this.totals = res.data.data.total;
            if (res.data.data.total == 0) {
              this.messgeheads = false;
            } else {
              this.messgeheads = true;
            }
            this.per_pages = res.data.data.per_page;
            this.pages.forEach((i) => {
              i.update_time = i.update_time.slice(0, 10);
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        return;
      }
    },

    // 设为已读
    searchDetails(index) {
      messageread({ id: this.pages[index].id }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 删除项目
    designDetails(index) {
      this.$confirm("此操作将删除此消息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          messagedel({ id: this.pages[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      //个人消息
      messageperson({ _keywords: this.inputss, page: this.thisNums }).then(
        (res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data.data;
            this.paginations = true;
            this.totals = res.data.data.total;
            if (res.data.data.total == 0) {
              this.messgeheads = false;
            } else {
              this.messgeheads = true;
            }
            this.per_pages = res.data.data.per_page;
            this.pages.forEach((i) => {
              i.update_time = i.update_time.slice(0, 10);
            });
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
  },
  created() {
    window.sessionStorage.setItem("default", "个人中心");
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    //个人消息
    messageperson({ page: this.thisNums }).then((res) => {
      if (res.data.code == 200) {
        this.pages = res.data.data.data;
        this.paginations = true;
        this.totals = res.data.data.total;
        if (res.data.data.total == 0) {
          this.messgeheads = false;
        } else {
          this.messgeheads = true;
        }
        this.per_pages = res.data.data.per_page;
        this.pages.forEach((i) => {
          i.update_time = i.update_time.slice(0, 10);
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
  <style scoped>
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.dark-theme {
  width: 100%;
  margin: auto;
  /* border-bottom: 1px solid #f1f1f1; */
  color: #525252;
}
.light-theme {
  width: 100%;
  margin: auto;
  /* border-bottom: 1px solid #f1f1f1; */
  color: #b1b1b1;
}
.Tablecont {
  border-bottom: 1px solid #efefef;
}
.hovercont:hover {
  background: #f7f9fc;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
</style>